import {FC, useEffect, useRef} from 'react'
import {useIntl} from 'react-intl'
import {useDispatch} from 'react-redux'
import {useAppSelector} from '../../../../setup/redux/hooks'
import {
  filterSchedulerDataChange,
  getAll,
  getAllLogs,
  selectSchedulerList,
  selectSchedulerLogs,
  selectSchedulerLogsFilter,
} from '../redux/SchedulerRedux'
import {SchedulerLogStatus} from '../constants'
import Paginator from '../../../components/Paginator'
import {SchedulerExecuteLogModel} from '../models/SchedulerExecuteLogModel'
import moment from 'moment'
import {Link} from 'react-router-dom'
import {SchedulerLogFilterModel} from '../models/SchedulerLogListFilterModel'

const SchedulerExecuteLogsTable: FC = () => {
  const intl = useIntl()
  const dispatch = useDispatch()

  const didRequest = useRef(false)
  const logs: SchedulerExecuteLogModel[] = useAppSelector(selectSchedulerLogs)
  const filter: SchedulerLogFilterModel = useAppSelector(selectSchedulerLogsFilter)
  useEffect(() => {
    if (!didRequest.current) {
      dispatch(getAllLogs(filter))
      didRequest.current = true
    }
  }, [])
  const handlePageChanged = (targetPage: number) => {
    dispatch(filterSchedulerDataChange({...filter, page: targetPage}))
  }

  return (
    <div className='py-4'>
      <div className='table-responsive'>
        <table className='table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3'>
          <thead>
            <tr className='fw-bold text-muted'>
              <th>{intl.formatMessage({id: 'SCHEDULER.LOGS.SCHEDULER_NAME'})}</th>
              <th>{intl.formatMessage({id: 'SCHEDULER.LOGS.EXECUTED_FOLDER'})}</th>
              <th>{intl.formatMessage({id: 'SCHEDULER.LOGS.SETTING'})}</th>
              <th>{intl.formatMessage({id: 'SCHEDULER.LOGS.STATUS'})}</th>
              {/* <th>{intl.formatMessage({id: 'SCHEDULER.LOGS.EXECUTED_AT'})}</th> */}
              <th>{intl.formatMessage({id: 'SCHEDULER.LOGS.COMPLETED_AT'})}</th>
              <th>{intl.formatMessage({id: 'SCHEDULER.LOGS.COMPLETED_FOLDER'})}</th>
              <th>{intl.formatMessage({id: 'SCHEDULER.LOGS.TOTAL_FILES'})}</th>
              <th>{intl.formatMessage({id: 'SCHEDULER.LOGS.TOTAL_CREDIT'})}</th>
              <th>{intl.formatMessage({id: 'SCHEDULER.LOGS.NOTE'})}</th>{' '}
            </tr>
          </thead>
          <tbody>
            {logs.map((log) => (
              <tr key={log.id}>
                <td>{log.settingName}</td>
                <td>
                  <Link to={`/schedulers/logs/${log.id}`}>{log.folderName}</Link>
                </td>
                <td>{log.settingReferenceName}</td>
                <td>
                  <span
                    className={`badge badge-light-${
                      log.status === SchedulerLogStatus.DONE ? 'success' : 'danger'
                    }`}
                  >
                    {intl.formatMessage({id: `SCHEDULER.LOGS.STATUS.${log.status}`})}
                  </span>
                </td>
                {/* <td>{moment(log.startAt).format(process.env.REACT_APP_DATE_TIME_FORMAT)}</td> */}
                <td>{moment(log.endAt).format(process.env.REACT_APP_DATE_TIME_FORMAT)}</td>
                <td>
                  {log.finishedOrder}/{log.totalOrder}
                </td>
                <td>{log.totalPhotos}</td>
                <td>{Number(log.credits).toFixed(1)}</td>
                <td>{log.note}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className='d-flex justify-content-end pt-10'>
        <Paginator
          currentPage={filter.page}
          totalPages={filter.pageCount || 1}
          onPageChange={handlePageChanged}
        />
      </div>
    </div>
  )
}

export default SchedulerExecuteLogsTable
